export default "__VITE_ASSET__0355258f__"